/*  ==========================================================================
    OFFERS TEASER
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {

    // calculate min price and add it to record
    utils.ehotelierPrices.initEhotelierOfferMinPrice(data);

}

// custom function
function funcCustom(container,data) {

    // initialize slider
    let $sliderContainer = $(container),
        sliderOverrides = {
            adaptiveHeight: true,
            dots: false,
            nextArrow: vars.slick_nextArrowV2,
            pauseOnHover: true,
            prevArrow: vars.slick_prevArrowV2,
        };
    utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);

}

// initialization
export function initOffersTeaser($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'offer',
        subtype: 'teaser'
    };

    // set a limit
    if ($(container).attr('data-limit')) {
        let limit = $(container).attr('data-limit');
        config.addParams.limit = limit;
    }

    // set category/ies
    if ($(container).attr('data-category')) {
        let category = $(container).attr('data-category');
        config.addParams.offercategories = category;
    }

    // ehotelier service initialization (if element is in view)
    $element.one('inview', function() {
        utils.ehotelierLoader.initEhotlierService(config);
    });

    // details as pop up
    utils.ehotelierPopUp.initEhotelierPopUp(container,config);

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/offers-teaser.js